// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoKeyOutlinedSvg from "@fishx/icons-svg/es/asn/PtoKeyOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoKeyOutlined = function PtoKeyOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoKeyOutlinedSvg
  }));
};

PtoKeyOutlined.displayName = 'PtoKeyOutlined';
export default React.forwardRef(PtoKeyOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoKeyOutlined.js
// module id = 3903
// module chunks = 0